import React, { useEffect, useState } from "react";
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/esm/Button";
import { useDispatch, useSelector } from "react-redux";

import BaseButton from "../../../../components/BaseButton";
import BottomBar from "../../../../components/BottomBar";
import TitleBar from "../../../../components/TitleBar";
import { retrieveMe, retrieveMyInquiry } from "../../../../sdk/apis";
import Inquiry from "../../../../sdk/containers/Inquiry";
import { setAccountInfo, setErrorMsg, setExtendExpiration, setInquiry, setValidateAccountSuccess, setValidateSuccess, validateAccount, validateInquiry } from '../../slice';
import { confirmUrl } from "../../urls";
import styles from './styles.module.css';

const TEXTAREA_ROWS = 10;
export const usageClassificationList = ["研究 (Research)", "教育 (Education)", "行政 (Administration)"];
export const usageClassificationEnList = ["research", "education", "administration"];

const InquiryForm = (props) => {
  const inquiry = useSelector((state) => state.inquiry.inquiry);
  const account = useSelector((state) => state.newAccount.accountInfo);
  const extendExpiration = useSelector((state) => state.inquiry.extendExpiration);

  const validateSuccess = useSelector((state) => state.inquiry.validateSuccess);
  const validateAccountSuccess = useSelector((state) => state.newAccount.validateSuccess);
  const errorMsg = useSelector((state) => state.inquiry.errorMsg);
  const accountErrorMsg = useSelector((state) => state.newAccount.errorMsg)
  // const forbidden = useSelector((state) => state.login.forbidden);
  const dispatch = useDispatch();

  // let forbiddenMessage = null;
  // if (forbidden) {
  //   forbiddenMessage = (
  //     <div className={styles.item} role="alert">
  //       まだログインしていないか、セッションが切れました。ログインし直してください。
  //     </div>
  //   )
  // }

  const [account_id, setAccount_id] = useState(null);
  const [username, setUsername] = useState(null);
  const [email, setEmail] = useState();
  const [category, setCategory] = useState(null);
  const [posetedDate, setPostedDate] = useState(null);


  useEffect(() => {
    retrieveMe().then((result) => {
      setAccount_id(result.account_id);
      setUsername(result.name);
      setEmail(result.email);
      setCategory(result.category);
      retrieveMyInquiry().then(result => {
        if (result.succeeded) {
          const formattedDate = new Date(result.date);
          setPostedDate(formattedDate);
        };
      });
    });
  }, []);

  const type = (new URL(document.location)).searchParams.get('type');

  let account_idForm = null;
  account_idForm = (
    <input name="account_id" type="text" className="form-control"
      value={inquiry.account_id}
      onChange={(e) => {
        const newInquiry = Object.create(inquiry);
        newInquiry.account_id = e.target.value;
        dispatch(setInquiry(newInquiry));
      }} />);
  if (account_id) {
    account_idForm = (
      <input name="account_id" type="text" className="form-control" value={account_id} disabled />
    );
  }

  let usernameForm = null;
  usernameForm = (
    <input name="username" type="text" className="form-control"
      value={inquiry.username}
      onChange={(e) => {
        const newInquiry = Object.create(inquiry);
        newInquiry.username = e.target.value;
        dispatch(setInquiry(newInquiry));
      }} />);
  if (username) {
    usernameForm = (
      <input name="username" type="text" className="form-control" value={username} disabled />
    );
  }

  let emailForm = null;
  emailForm = (
    <input name="email" type="text" className="form-control"
      value={inquiry.email}
      onChange={(e) => {
        const newInquiry = Object.create(inquiry);
        newInquiry.email = e.target.value;
        dispatch(setInquiry(newInquiry));
      }} />);
  if (email) {
    emailForm = (
      <input name="email" type="text" className="form-control" value={email} disabled />
    );
  }

  const usageClassifications = document.getElementById('usageClassification');
  if (usageClassifications && usageClassifications.length === 1) {
    usageClassificationList.forEach((classification, index) => {
      const classChoice = document.createElement('option');
      classChoice.value = index;
      classChoice.innerHTML = classification;
      usageClassifications.appendChild(classChoice);
    });
  }


  let forms = null;
  let title = null;
  let titleEn = null;
  let inquiryButtonColor = null;
  let extendExpirationColor = null;
  const getButtons = (type, category) => {
    if (category !== 'public' && category !== 'gaikoku') {
      return;
    }
    if (type === 'account') {
      return;
    } else {
      return (
        <>
          <Button className="button-xs" variant={inquiryButtonColor} size="sm"
            onClick={() => {
              dispatch(setExtendExpiration(false));
              dispatch(setErrorMsg(new Inquiry()));
              const newInquiry = Object.create(inquiry);
              newInquiry.subject = "";
              newInquiry.body = "";
              dispatch(setInquiry(newInquiry));
            }}>お問い合わせ</Button>
          &nbsp;
          <Button className="button-xs" variant={extendExpirationColor} size="sm"
            onClick={() => {
              const newInquiry = Object.create(inquiry);
              dispatch(setExtendExpiration(true));
              dispatch(setErrorMsg(new Inquiry()));
              if (account_id) { newInquiry.account_id = account_id }
              if (username) { newInquiry.username = username }
              if (email) { newInquiry.email = email; }
              newInquiry.subject = "アカウント有効期限延長申請";
              newInquiry.body = "アカウントの有効期限延長を申請します。";
              dispatch(setInquiry(newInquiry));
            }}>アカウント有効期限延長</Button>
        </>
      )
    }
  };

  const getSubmitButton = () => {
    if (extendExpiration && posetedDate) {
      return;
    } else {
      return (
        <>
          <BaseButton onClick={() => {
            if (type === 'account') {
              dispatch(validateAccount(account));
            } else if (extendExpiration) {
              dispatch(validateInquiry(inquiry, true));
            } else {
              dispatch(validateInquiry(inquiry, false));
            }
          }}>
            確認画面へ移る
            <br />
            To Confirmation Page
          </BaseButton>
        </>
      )
    }
  };

  if (type === 'account') {
    title = "新規アカウント申請";
    titleEn = "Application for a New Account";
    forms = (
      <>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="name">氏名 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.name}</b></label>
            <label htmlFor="name">Name <small><notice>※Required</notice></small><b>&nbsp;&nbsp;&nbsp;{!!accountErrorMsg.name && `This field is required.`}</b></label>
          </div>
          <input name="name" type="text" className="form-control"
            value={account.name}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.name = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="name_f">氏名（ローマ字） <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.name_f}</b></label>
            <label htmlFor="name_f">Name (Alphabet) <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.name_fEn}</b></label>
          </div>
          <input name="name_f" type="text" className="form-control"
            value={account.name_f}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.name_f = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="email">Email <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.email}</b></label>
            <label htmlFor="email">Email <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.emailEn}</b></label>
          </div>
          <input name="email" type="email" className="form-control"
            value={account.email}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.email = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="organization">所属機関 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;該当しない場合は「なし」と記入してください。&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.organization}</b></label>
            <label htmlFor="organization">Organization <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;If not applicable, please enter "N/A".&nbsp;&nbsp;&nbsp;<b>{!!accountErrorMsg.organization && `This field is required.`}</b></label>
          </div>
          <input name="organization" type="text" className="form-control"
            value={account.organization}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.organization = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="organization_f">所属機関（フリガナ） <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;該当しない場合は「ナシ」と記入してください。&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.organization_f}</b></label>
            <label htmlFor="organization_f">Organization (furigana) <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;If not applicable, please enter "N/A".&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.organization_fEn}</b></label>
          </div>
          <input name="organization_f" type="text" className="form-control"
            value={account.organization_f}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.organization_f = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="department">所属部署 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;該当しない場合は「なし」と記入してください。&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.department}</b></label>
            <label htmlFor="department">Department <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;If not applicable, please enter "N/A".&nbsp;&nbsp;&nbsp;<b>{!!accountErrorMsg.department && `This field is required.`}</b></label>
          </div>
          <input name="department" type="text" className="form-control"
            value={account.department}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.department = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="department_f">所属部署（フリガナ） <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;該当しない場合は「ナシ」と記入してください。&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.department_f}</b></label>
            <label htmlFor="department_f">Department (furigana) <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;If not applicable, please enter "N/A".&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.department_fEn}</b></label>
          </div>
          <input name="department_f" type="text" className="form-control"
            value={account.department_f}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.department_f = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="job_title">役職 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;該当しない場合は「なし」と記入してください。&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.job_title}</b></label>
            <label htmlFor="job_title">Position <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;If not applicable, please enter "N/A".&nbsp;&nbsp;&nbsp;<b>{!!accountErrorMsg.job_title && `This field is required.`}</b></label>
          </div>
          <input name="job_title" type="text" className="form-control"
            value={account.job_title}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.job_title = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="job_title_f">役職（フリガナ） <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;該当しない場合は「ナシ」と記入してください。&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.job_title_f}</b></label>
            <label htmlFor="job_title_f">Position（furigana） <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;If not applicable, please enter "N/A".&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.job_title_fEn}</b></label>
          </div>
          <input name="job_title_f" type="text" className="form-control"
            value={account.job_title_f}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.job_title_f = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="address">住所 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.address}</b></label>
            <label htmlFor="address">Address <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;<b>{!!accountErrorMsg.address && `This field is required.`}</b></label>
          </div>
          <input name="address" type="text" className="form-control"
            value={account.address}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.address = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="tel">電話番号<small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.tel}</b></label>
            <label htmlFor="tel">Telephone number<small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;<b>{!!accountErrorMsg.tel && `This field is required.`}</b></label>
          </div>
          <input name="tel" type="text" className="form-control"
            value={account.tel}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.tel = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="usageClassification">利用区分 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.usage_classification}</b></label>
            <label htmlFor="usageClassification">Division <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;<b>{!!accountErrorMsg.usage_classification && `This field is required.`}</b></label>
          </div>
          <select name='usageClassification' id="usageClassification"
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.usage_classification = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} >
            <option disabled selected></option>
            {usageClassificationList.map((elem, idx) => <option value={idx}>{elem}</option>)}
          </select>
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="purpose">利用目的 <small><notice>※必須</notice>&nbsp;&nbsp;具体的な目的を記入してください</small>&nbsp;&nbsp;&nbsp;<b>{accountErrorMsg.purpose}</b></label>
            <label htmlFor="purpose">Purpose <small><notice>※Required</notice></small>&nbsp;&nbsp;&nbsp;<b>{!!accountErrorMsg.purpose && `This field is required.`}</b></label>
          </div>
          <input name="purpose" type="text" className="form-control"
            value={account.purpose}
            onChange={(e) => {
              const newAccount = Object.create(account);
              newAccount.purpose = e.target.value;
              dispatch(setAccountInfo(newAccount));
            }} />
        </div>
      </>
    )
  }
  else if (extendExpiration) {
    title = "アカウント有効期限延長";
    inquiryButtonColor = "outline-secondary";
    extendExpirationColor = "success";
    if (posetedDate) {
      const date = new Date(posetedDate);
      const formattedDate = date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate()
      forms = (
        <>
          <div style={{ backgroundcolor: '#882231' }}>
            <br></br>
            <p>アカウント期限延長申請済みです。申請日：{formattedDate}</p>
            <p>承認まで今しばらくお待ちください。延長申請が承認された場合、メールにてお知らせします。</p>
          </div>
        </>
      )
    } else {
      forms = (
        <>
          <div className={styles.item}>
            <label htmlFor="account_id" className="form-label">ユーザーID <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.account_id}</b></label>
            {account_idForm}
          </div>
          <div className={styles.item}>
            <label htmlFor="username" className="form-label">氏名 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.username}</b></label>
            {usernameForm}
          </div>
          <div className={styles.item}>
            <label htmlFor="email" className="form-label">Email <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.email}</b></label>
            {emailForm}
          </div>
          <div className={styles.item}>
            <label htmlFor="subject" className="form-label">件名 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.subject}</b></label>
            <input name="subject" type="text" className="form-control" disabled={extendExpiration}
              value={inquiry.subject}
              onChange={(e) => {
                const newInquiry = Object.create(inquiry);
                if (account_id) { newInquiry.account_id = account_id; }
                if (username) { newInquiry.username = username; }
                if (email) { newInquiry.email = email; }
                newInquiry.subject = e.target.value;
                dispatch(setInquiry(newInquiry));
              }} />
          </div>
          <div className={styles.item}>
            <label htmlFor="body" className="form-label">お問い合わせ内容 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.body}</b></label>
            <textarea name="body" type="text" className="form-control" rows={TEXTAREA_ROWS}
              value={inquiry.body}
              onChange={(e) => {
                const newInquiry = Object.create(inquiry);
                if (account_id) { newInquiry.account_id = account_id; }
                if (username) { newInquiry.username = username; }
                if (email) { newInquiry.email = email; }
                newInquiry.body = e.target.value;
                dispatch(setInquiry(newInquiry));
              }}
            />
          </div>
        </>
      )
    }
  }
  else {
    title = "お問い合わせ";
    titleEn = "Inquiry";
    inquiryButtonColor = "success";
    extendExpirationColor = "outline-secondary";
    forms = (
      <>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="account_id">ユーザーID <small><notice>※アカウント登録済みの方のみ必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.account_id}</b></label>
            <label htmlFor="account_id">User ID <small><notice>※required if you have</notice></small></label>
          </div>
          {account_idForm}
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="username">氏名 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.username}</b></label>
            <label htmlFor="username">User Name <small><notice>※required</notice></small></label>
          </div>
          {usernameForm}
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="email">Email <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.email}</b></label>
            <label htmlFor="email">Email address<small><notice>※required</notice></small></label>
          </div>
          {emailForm}
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="subject">件名 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.subject}</b></label>
            <label htmlFor="subject">Mail Title <small><notice>※required</notice></small></label>
          </div>
          <input name="subject" type="text" className="form-control"
            value={inquiry.subject}
            onChange={(e) => {
              const newInquiry = Object.create(inquiry);
              if (account_id) { newInquiry.account_id = account_id; }
              if (username) { newInquiry.username = username; }
              if (email) { newInquiry.email = email; }
              newInquiry.subject = e.target.value;
              dispatch(setInquiry(newInquiry));
            }} />
        </div>
        <div className={styles.item}>
          <div className={styles.labels}>
            <label htmlFor="body">お問い合わせ内容 <small><notice>※必須</notice></small>&nbsp;&nbsp;&nbsp;<b>{errorMsg.body}</b></label>
            <label htmlFor="body">Inquiry Detail <small><notice>※required</notice></small></label>
          </div>
          <textarea name="body" type="text" className="form-control" rows={TEXTAREA_ROWS}
            value={inquiry.body}
            onChange={(e) => {
              const newInquiry = Object.create(inquiry);
              if (account_id) { newInquiry.account_id = account_id; }
              if (username) { newInquiry.username = username; }
              if (email) { newInquiry.email = email; }
              newInquiry.body = e.target.value;
              dispatch(setInquiry(newInquiry));
            }} />
        </div>
      </>
    )
  }

  if (validateAccountSuccess) {
    setValidateSuccess(false);
    props.history.push({
      pathname: confirmUrl(),
      search: '?type=account',
      state: { account: account }
    });
  }
  if (validateSuccess) {
    setValidateAccountSuccess(false);
    props.history.push({
      pathname: confirmUrl(type),
      state: { inqury: inquiry }
    });
  }
  // useEffect(() => {
  //   console.log(Object.keys(errorMsg))
  //   console.log(Object.keys(errorMsg).length)
  //   console.log(Object.keys(accountErrorMsg).length)
  //   if (Object.keys(errorMsg).length > 0 || Object.keys(accountErrorMsg).length > 0) {
  //     setErrorNotice(
  //       <>
  //         &nbsp;
  //         <Alert variant="danger">入力項目にエラーがあります。メッセージを確認し、修正してください。</Alert>
  //       </>);
  //   } else {
  //     setErrorNotice(null);
  //   }
  // }, [errorMsg, accountErrorMsg]);

  return (
    <>
      <TitleBar />
      <div className={styles.title}>
        {title}
        <br />
        {titleEn}
      </div>
      <div className={styles.inquiryform}>
        {getButtons(type, category)}
        {forms}
        <div className={styles.item}>
          {getSubmitButton()}
        </div>
      </div>
      <div className="blank"></div>
      <BottomBar />
    </>
  );
};

export default InquiryForm;
